module.exports = __webpack_public_path__ + "static/media/pe-icon-set-weathere60d.64b30451.woff";